import { FOCUSABLES_SELECTOR, isElementFocusable } from './is-focusable';

let modalIndex = 10;
export default function toggleElement( elementOrId, show, focus ) {
	if ( ! elementOrId ) {
		return;
	}

	let target, targetId;
	if ( typeof elementOrId === 'string' ) {
		targetId = elementOrId;
		target = document.getElementById( targetId );
	} else {
		target = elementOrId;
		targetId = target.id;
	}

	if ( ! target ) {
		return;
	}

	// Get the controls for this element
	const controls = document.querySelectorAll( `[aria-controls="${ targetId }"], [data-target="${ targetId }"]` );

	if ( typeof show === 'undefined' || show === null ) {
		// Toggle based on target's hidden status
		show = target.getAttribute( 'aria-hidden' ) === 'true';
	}

	// Update the controls if applicable
	controls.forEach( control => {
		if ( control.hasAttribute( 'aria-expanded' ) ) {
			control.setAttribute( 'aria-expanded', show );
		}
		if ( control.hasAttribute( 'aria-selected' ) ) {
			control.tabIndex = show ? null : -1;
			control.setAttribute( 'aria-selected', show );
		}
	} );

	// Hide/show the target
	target.setAttribute( 'aria-hidden', ! show );
	if ( show && focus ) {
		if ( target.getAttribute( 'role' ) === 'dialog' && target.classList.contains( 'js-modal--stackable' ) ) {
			// If it's a modal, update the z-index to the next level up
			target.style.zIndex = ++modalIndex;
		}

		const autofocus = [ ...target.querySelectorAll( '[autofocus]' ) ].find( isElementFocusable );

		// If target contains an autofocus element, focus that
		if ( autofocus ) {
			autofocus.focus();

			// If target itself is meant to be focused (is tabble or has explicit tabindex)
		} else if ( target.tabIndex > 0 || target.hasAttribute( 'tabindex' ) ) {
			target.focus( { preventScroll: true } );
		} else {
			// Find the first focusable element within and focus that
			const focusable = [ ...target.querySelectorAll( FOCUSABLES_SELECTOR ) ].find( isElementFocusable );
			if ( focusable ) {
				focusable.focus();
			}
		}
	}

	// Hide siblings if part of a group
	if ( show && target.dataset.toggleGroup ) {
		document.querySelectorAll( `[data-toggle-group="${ target.dataset.toggleGroup }"][aria-hidden="false"]` ).forEach( sibling => {
			if ( sibling !== target ) {
				toggleElement( sibling, false );
			}
		} );
	}

	// Trigger event for target ID
	const event = new CustomEvent( `toggle-${ show ? 'on' : 'off' }`, {
		bubbles: true,
	} );
	target.dispatchEvent( event );

	return show;
}
